// extracted by mini-css-extract-plugin
export var about = "About-module--about--b9eae";
export var fadeIn = "About-module--fadeIn--a182b";
export var fadeOut = "About-module--fadeOut--63a46";
export var hero = "About-module--hero--f7361";
export var heroStats = "About-module--hero__stats--96937";
export var heroStatsDivider = "About-module--hero__stats__divider--3da69";
export var heroStatsItem = "About-module--hero__stats__item--bdd7f";
export var mission = "About-module--mission--de9cd";
export var missionContainer = "About-module--mission__container--2b5d5";
export var paragraph = "About-module--paragraph--8b129";
export var paragraphSm = "About-module--paragraph-sm--19ec5";
export var paragraphXs = "About-module--paragraph-xs--37a5a";
export var raise = "About-module--raise--4a500";
export var raiseContainer = "About-module--raise__container--10ada";
export var raiseContent = "About-module--raise__content--ab80c";
export var security = "About-module--security--04845";
export var securityContainer = "About-module--security__container--b2ef7";
export var securityLogos = "About-module--security__logos--ba549";
export var securityLogosDivider = "About-module--security__logos__divider--368b8";
export var staff = "About-module--staff--211c8";
export var staffCarousel = "About-module--staff__carousel--63742";
export var staffCarouselImg = "About-module--staff__carousel__img--815b4";
export var staffContainer = "About-module--staff__container--c300d";
export var titleH1 = "About-module--title-h1--47514";
export var titleH2 = "About-module--title-h2--6a0d6";
export var titleH3 = "About-module--title-h3--68230";
export var titleH3Alt = "About-module--title-h3--alt--6f818";
export var titleH4 = "About-module--title-h4--cfb42";
export var titleH5 = "About-module--title-h5--67666";